module.exports = __webpack_public_path__ + "static/media/mp.9b0bcd39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mp.png
// module id = 1927
// module chunks = 0